import { render, staticRenderFns } from "./SoliUserInstruments.vue?vue&type=template&id=fbec7020"
import script from "./SoliUserInstruments.vue?vue&type=script&lang=js"
export * from "./SoliUserInstruments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports